import axios from "./productInstance"
import store from "@/store";
import {snapshot} from "valtio";

export default async () => {

    //const {companySetting} = snapshot(store)
    //const machine = companySetting.machine;
    //const storeType = machine ? "shopify" : "woocommerce";

    try {
         let response: any
        // if (storeType === 'woocommerce') {
        //     response = await axios.post(`/products/woocommerce-sync`)
        // } else {
             response = await axios.post(`/products/sync/async`)
        // }
        return response.data
    } catch (error) {
        return null
    }
}
